var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav-bar", {
    staticClass: "c-navBar",
    attrs: { logout: _vm.logout, "user-info": _vm.user.profile }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }